import { CubeTimeDimensionGranularity } from "../../../enum/cube-schema.enum";
import { CubeConfigDto } from "../../common/request/cube-config.dto";

export interface QueryAllScoresRequestParamsDto {
    startDate: string;
    endDate: string;
    granularity?: CubeTimeDimensionGranularity;
}